import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {first} from 'rxjs/operators';

export class ApplicationSettings {

  security = {
    useContext: false
  };

  appName: string;
}

@Injectable({ providedIn: 'root' })
export class SystemSettingsService {

  public settings: ApplicationSettings;

  constructor(private http: HttpClient) {}

  public load(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.http.get<ApplicationSettings>('auth/settings').pipe(first()).subscribe(value => {
        this.settings = value;
        resolve(true);
      });
    });
  }
}
